import React from "react";

// Modules
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// App
import { serverUrl, counterEnabled } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import Pagination from "../../partials/pagination";
import PageHeader from "../../partials/pageHeader";
import Error from "../../partials/error";
// import { _checkContent } from '../../core/checkContent';
import NoData from "../../partials/noData";
import Forum from "./forum";
import { patchNode } from "../../core/postNode";
import { alertMessages } from '../../partials/alertMessages';

// UI components
import Row from "react-bootstrap/Row";
import CompanyappLoader from "../../partials/companyappLoader";

const pageSize = 20;

export default function ForumsBoard(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [forums, setForums] = useState([]);

  const user = useSelector((state) => state).authReducer.user;
  const counter = useSelector((state) => state).counterReducer;

  // hooks
  const dispatch = useDispatch();

  useEffect(() => {
    getForums();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (counterEnabled) {
      updateRemoteCounter();
    }
    // eslint-disable-next-line
  }, []);

  const getForums = () => {
    getOnlineNode(
      // 'all_categories/news_categories',
      "api/categories?vid=forums",
      user.access_token,
    )
      .then((response) => {
        setForums(response.data);
        setIsLoading(false);
      })
      .catch((_error) => {
        console.log("error: ", _error);
      });
  };

  /**
   * @function onPaginate
   * @description Pagination callback
   * @param {int} _index - Page number
   */
  const onPaginate = (_index) => {
    setIsLoading(true);

    setCurrentPage(_index);
  };

  /**
   * @function handleCategorySelection
   * @description Modal Picker callback / Updates the header title and sets the state to the selected category
   * @param {string} _id - Category ID
   */

  // Pagination component
  const renderPagination = () => {
    return (
      <Pagination
        owner="client"
        containerClasses={`creator-pagination d-flex justify-content-center align-items-center mt-4`}
        previousDisabled={currentPage === 1 ? true : false}
        nextDisabled={forums.length < pageSize ? true : false}
        currentPage={currentPage}
        onPrevious={() => {
          onPaginate(currentPage - 1);
        }}
        onNext={() => {
          onPaginate(currentPage + 1);
        }}
      />
    );
  };

  // Data component
  const dataComponent = () => {
    if (typeof forums !== "undefined" && forums.length > 0) {
      return (
        <Row>
          {forums.map((item, index) => {
            return <Forum key={`forum-${index}`} item={item} />;
          })}
        </Row>
      );
    } else {
      return <NoData activeIndex={activeIndex} />;
    }
  };

  // Updates content counter
  const updateRemoteCounter = () => {
    const updateData = {
      contentType: "forum",
      acknowledgedCount: counter?.contentCounts?.forum || 0,
    };

    patchNode(`${serverUrl}/api/v2/counter`, updateData, user.csrf_token)
      .then((response) => {
        if (response.data) {
          dispatch({ type: "UPDATE_COUNTER", payload: response.data });
        }
      })
      .catch((error) => {
        setIsError(true);
        setErrorStatus(0);
        setErrorMessage(alertMessages.requestError.message);
        setIsLoading(false);
      });
  };

  return (
    <>
      {isError ? (
        <Error status={errorStatus} message={errorMessage} />
      ) : (
        <main className="forums  screen">
          <PageHeader
            pageName="Discussion Boards"
            // filters={true}
            owner="client"
            pageNameColor="clientText.dark"
            getContent={() => {
              setActiveIndex(0);
              setIsLoading(true);
            }}
            activeTabIndex={activeIndex}
          />
          {isLoading ? (
            <CompanyappLoader />
          ) : (
            <>
              {dataComponent()}
              {renderPagination()}
            </>
          )}
        </main>
      )}
    </>
  );
}
